import React, { useEffect, useState } from 'react';
import { Localizer } from 'services/Localizer';
import { AddToCartResponse } from 'services/UserData.Commerce';
import ProductPricing from 'shared/components/commerce/ProductPricing';
import LockSVG from 'shared/components/svg/LockSVG';
import OrderMessages from '../shopping-cart/OrderMessages';

interface AddedToCartAlertProps {
	response: AddToCartResponse;
}

/**
 * Displays Added to Cart confirmation
 */
export default function AddedToCartAlert(props: AddedToCartAlertProps) {
	const { response } = props;
	const [displayAlert, setDisplayAlert] = useState(true);

	useEffect(() => {
		setDisplayAlert(true);
	}, [response]);

	if (!displayAlert) {
		return null;
	}

	return (
		<div className="roc-item-summary" data-testid="added-to-cart-alert">
			<OrderMessages orderMessages={response.orderMessages} />
			<div className="roc-item-summary__section">
				<div className="roc-item-summary__item">
					<div className="roc-item-summary__image-wrapper">
						{response.imageUrl ? (
							<img className="roc-item-summary__image" alt={response.name} src={response.imageUrl} />
						) : (
							<img
								className="roc-item-summary__image"
								alt={response.name}
								src="/images/image-not-found-medium.png"
							/>
						)}
					</div>
					<div className="roc-item-summary__text">
						<p>
							<strong>{response.name}</strong>
						</p>
						<p>
							<strong>{Localizer('SKU')}: </strong>
							<span data-testid="added-to-cart-sku">{response.sku}</span>
						</p>

						<ProductPricing inline displayPrice={response.displayPrice} />

						<table className="roc-item-summary__attributes">
							<tbody>
								{response.selections !== null && response.selections.length > 0
									? //#region Tapecase customization
									  response.selections
											.filter((sel) => sel.name.toUpperCase() != 'SKU')
											.map((selection) => (
												//#end region
												<tr
													className="roc-item-summary__row"
													key={`added-to-cart-alert-selection-${selection.name}`}
												>
													<td className="roc-item-summary__col roc-item-summary__col--property">
														<strong>{selection.name}:</strong>
													</td>

													<td className="roc-item-summary__col roc-item-summary__col--value">
														{selection.label}
													</td>
												</tr>
											))
									: null}

								<tr className="roc-item-summary__row">
									<td className="roc-item-summary__col roc-item-summary__col--property">
										<strong>{Localizer('Qty')} </strong>
									</td>

									<td className="roc-item-summary__col roc-item-summary__col--value">
										{response.adjustedQuantity}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div className="roc-item-summary__section">
				<div className="roc-item-summary__final-wrapper">
					<span className="roc-item-summary__final-count">
						{Localizer('InCart')} {response.cartSummary.items}
					</span>
					<span className="roc-item-summary__final">
						<span className="roc-item-summary__final-text">{Localizer('Subtotal')}:</span>
						<ProductPricing
							inline
							displayPrice={response.cartSummary.subtotal}
							className="roc-item-summary__final-value"
						/>
					</span>
				</div>
				<div className="roc-item-summary__btn-row">
					<div className="roc-item-summary__btn-col">
						<button
							type="button"
							onClick={() => (window.location.href = '/cart')}
							className="roc-btn roc-btn--big roc-btn--block roc-item-summary__btn"
							data-testid="view-cart-modal-btn"
						>
							{Localizer('ViewCart')}
						</button>
					</div>
					<div className="roc-item-summary__btn-col">
						<button
							type="button"
							onClick={() => (window.location.href = '/checkout')}
							className="roc-btn roc-btn--big roc-btn--block roc-item-summary__btn"
							data-testid="checkout-modal-btn"
						>
							<LockSVG className={'roc-item-summary__btn-icon'} />
							<span className="roc-item-summary__btn-text" data-testid="checkout-now-button">
								{Localizer('CheckoutNow')}
							</span>
						</button>
					</div>
				</div>
			</div>
		</div>

		// <div>
		// 	<div style={{ display: 'flex' }}>
		// 		<div>
		// 			<p>Added to Cart</p>
		// 		</div>
		// 		<div style={{ width: '50%', textAlign: 'right' }}>
		// 			<button type="button" onClick={() => setDisplayAlert(false)}>
		// 				Close
		// 			</button>
		// 		</div>
		// 	</div>
		// 	<div style={{ display: 'flex' }}>
		// 		<div style={{ width: '40%' }}>
		// 			{response.imageUrl ? (
		// 				<img src={response.imageUrl} style={{ maxWidth: '100%' }} />
		// 			) : (
		// 				<img src="https://via.placeholder.com/180x180" />
		// 			)}
		// 		</div>
		// 		<div style={{ width: '60%' }}>
		// 			<div>{response.name}</div>
		// 			<div>
		// 				{response.salePrice != null ? (
		// 					<>
		// 						<span style={{ textDecoration: 'line-through' }}>
		// 							${formatPrice(response.basePrice)}
		// 						</span>
		// 						<span style={{ color: 'red' }}>${formatPrice(response.salePrice)}</span>
		// 					</>
		// 				) : (
		// 					<span>${formatPrice(response.basePrice)}</span>
		// 				)}
		// 			</div>
		// 			{response.selections !== null &&
		// 				response.selections.length > 0 &&
		// 				response.selections.map(selection => (
		// 					<div>
		// 						{selection.name}: {selection.label}
		// 					</div>
		// 				))}
		// 			<div>Qty: {response.adjustedQuantity}</div>
		// 		</div>
		// 	</div>

		// 	<hr />
		// 	<div style={{ display: 'flex' }}>
		// 		<div style={{ width: '50%' }}>
		// 			{response.cartSummary.items} {response.cartSummary.items === 1 ? 'item' : 'items'} in cart
		// 		</div>
		// 		<div style={{ width: '50%', textAlign: 'right' }}>
		// 			Subtotal: ${formatPrice(response.cartSummary.subtotal)}
		// 		</div>
		// 	</div>
		// 	<div style={{ display: 'flex' }}>
		// 		<div style={{ width: '50%' }}>
		// 			<button type="button" onClick={() => (window.location.href = '/cart')}>
		// 				View Cart
		// 			</button>
		// 		</div>
		// 		<div style={{ width: '50%', textAlign: 'right' }}>
		// 			<button type="button" onClick={() => (window.location.href = '/checkout')}>
		// 				Checkout Now
		// 			</button>
		// 		</div>
		// 	</div>
		// </div>
	);
}
